module.exports = __webpack_public_path__ + "images/6ab30bfb210856a9691ac99ba58487db.png";